export default __webpack_public_path__ + "ui/assets/img/balance-20.svg";